import React from 'react';
import PropTypes from 'prop-types';

// mode: 'active' | 'thinking' | 'fading-in'
const RoleplayPinnedPanel = ({ characterName, characterRole, utterance, mode, onPlayUtterance, isPlayingUtterance }) => (
  <div className="rp-pinned-panel">
    <div className="rp-pinned-header">
      <span className="rp-pinned-char-name">{characterName}</span>
      {characterRole && (
        <span className="rp-pinned-char-role">{characterRole}</span>
      )}
    </div>

    {mode === 'thinking' ? (
      <div className="rp-thinking-dots">
        <div className="rp-thinking-dot" />
        <div className="rp-thinking-dot" />
        <div className="rp-thinking-dot" />
      </div>
    ) : (
      <div className="rp-pinned-utterance-row">
        <p className={`rp-pinned-utterance${mode === 'fading-in' ? ' fading-in' : ''}`}>
          {utterance}
        </p>
        {mode === 'active' && utterance && onPlayUtterance && (
          <button
            className={`rp-pinned-play-btn${isPlayingUtterance ? ' rp-pinned-play-btn--active' : ''}`}
            onClick={onPlayUtterance}
            disabled={isPlayingUtterance}
            aria-label="Play character line"
          >
            {isPlayingUtterance ? '…' : '▶'}
          </button>
        )}
      </div>
    )}
  </div>
);

RoleplayPinnedPanel.propTypes = {
  characterName: PropTypes.string.isRequired,
  characterRole: PropTypes.string,
  utterance: PropTypes.string,
  mode: PropTypes.oneOf(['active', 'thinking', 'fading-in']).isRequired,
  onPlayUtterance: PropTypes.func,
  isPlayingUtterance: PropTypes.bool,
};

export default RoleplayPinnedPanel;
